import React, { SVGProps } from "react";
const SvgBiotechnology = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={27.774} viewBox="0 0 27.774 20.524" {...props}>
      <g data-name="Group 264" transform="translate(.434 .427)">
        <path
          data-name="Path 816"
          d="M8.015 11.543A4.057 4.057 0 0 0 4.71 5.128H1.279A1.279 1.279 0 0 0 0 6.41v11.981a1.279 1.279 0 0 0 1.279 1.279H5.42a4.394 4.394 0 0 0 4.389-4.389v-.2a4.385 4.385 0 0 0-1.794-3.537ZM2.559 7.687H4.71a1.5 1.5 0 1 1 0 3H2.558Zm4.692 7.591a1.833 1.833 0 0 1-1.831 1.831H2.558V13.25H5.42a1.833 1.833 0 0 1 1.831 1.831v.2Z"
          fill="#ffcd27"
        />
        <g data-name="Group 261">
          <g data-name="Group 260" fill="#ffb541">
            <path
              data-name="Path 817"
              d="M1.582 13.523v3.317a.271.271 0 0 0 .271.271h.705v-3.856h-.705a.271.271 0 0 0-.271.268Z"
            />
            <path
              data-name="Path 818"
              d="M8.019 11.543a4.038 4.038 0 0 0 .755-2.409 4.1 4.1 0 0 0-4.115-4.006h-.922a4.057 4.057 0 0 1 3.442 6.211.271.271 0 0 0 .057.355 4.381 4.381 0 0 1 1.6 3.386v.2a4.394 4.394 0 0 1-4.389 4.389h.972a4.389 4.389 0 0 0 4.389-4.389v-.2a4.385 4.385 0 0 0-1.789-3.537Z"
            />
            <path
              data-name="Path 819"
              d="M1.853 10.693h.705v-3h-.705a.271.271 0 0 0-.271.271v2.462a.271.271 0 0 0 .271.267Z"
            />
          </g>
        </g>
        <g data-name="Group 262">
          <path
            data-name="Path 820"
            d="M11.089 19.67a1.279 1.279 0 0 1-1.279-1.279V6.41a1.28 1.28 0 1 1 2.559 0v11.981a1.279 1.279 0 0 1-1.28 1.279Z"
            fill="#ffcd27"
          />
        </g>
        <path
          data-name="Path 821"
          d="M11.088 5.131a1.274 1.274 0 0 0-.488.1 1.279 1.279 0 0 1 .791 1.183v11.981a1.279 1.279 0 0 1-.791 1.183 1.279 1.279 0 0 0 1.767-1.183V6.41a1.279 1.279 0 0 0-1.279-1.279Z"
          fill="#ffb541"
        />
        <g data-name="Group 263">
          <path
            data-name="Path 822"
            d="M10.334.684A4.031 4.031 0 0 0 7.592.022a3.126 3.126 0 0 0 .731 2.484 4.031 4.031 0 0 0 2.742.662 3.126 3.126 0 0 0-.731-2.484Z"
            fill="#aee295"
          />
          <path
            data-name="Path 823"
            d="M14.587.021a4.031 4.031 0 0 0-2.742.662 3.126 3.126 0 0 0-.731 2.484 4.031 4.031 0 0 0 2.742-.662 3.126 3.126 0 0 0 .731-2.484Z"
            fill="#aee295"
          />
          <path
            data-name="Path 824"
            d="M10.334.684A4.031 4.031 0 0 0 7.592.022a3.126 3.126 0 0 0 .731 2.484 4.031 4.031 0 0 0 2.742.662 3.126 3.126 0 0 0-.731-2.484Z"
            fill="#12b05e"
          />
          <path
            data-name="Path 825"
            d="M14.587.021a4.031 4.031 0 0 0-2.742.662 3.126 3.126 0 0 0-.731 2.484 4.031 4.031 0 0 0 2.742-.662 3.126 3.126 0 0 0 .731-2.484Z"
            fill="#12b05e"
          />
        </g>
        <path
          data-name="Path 826"
          d="M8.322 1.529A2.457 2.457 0 0 1 7.605.02h-.014a3.126 3.126 0 0 0 .731 2.484 4.031 4.031 0 0 0 2.742.662 3.915 3.915 0 0 0-.014-.975 3.984 3.984 0 0 1-2.728-.662Z"
          fill="#98db7c"
        />
        <path
          data-name="Path 827"
          d="M14.571.02a2.457 2.457 0 0 1-.717 1.509 3.983 3.983 0 0 1-2.728.663 3.915 3.915 0 0 0-.014.975 4.031 4.031 0 0 0 2.742-.662 3.126 3.126 0 0 0 .731-2.484Z"
          fill="#98db7c"
        />
        <circle
          data-name="Ellipse 57"
          cx={7.27}
          cy={7.27}
          r={7.27}
          transform="translate(12.367 5.131)"
          fill="#428fce"
        />
        <path
          data-name="Path 828"
          d="M19.637 5.131c-.164 0-.327.006-.488.017a7.269 7.269 0 0 1 0 14.506c.161.011.324.017.488.017a7.27 7.27 0 1 0 0-14.539Z"
          fill="#71bff4"
        />
        <path
          data-name="Path 829"
          d="M14.37 17.411a1.723 1.723 0 0 1 .663-.652c.913-.465 1.583-1.23 2.252-.726s-.223 1.448.5 1.935c.524.354 1.1 1.046.838 1.631a7.252 7.252 0 0 1-4.253-2.188Z"
          fill="#12b05e"
        />
        <path
          data-name="Path 830"
          d="M22.24 13.833c.664.322 1.488-.7 2.728-.925a1.813 1.813 0 0 1 1.838.7 7.279 7.279 0 0 1-4.306 5.475 1.3 1.3 0 0 1-.831-2.034c.572-.885-1.2-1.143-1.272-2.322s1.179-1.216 1.843-.894Z"
          fill="#12b05e"
        />
        <path
          data-name="Path 831"
          d="M25.909 12.961a7.272 7.272 0 0 1-3.953 5.922.964.964 0 0 0 .545.2 7.279 7.279 0 0 0 4.306-5.475 1.794 1.794 0 0 0-.898-.647Z"
          fill="#98db7c"
        />
        <path
          data-name="Path 832"
          d="M19.637 5.131a7.241 7.241 0 0 1 3.056.672c-.038 0-2.424.207-2.454.72s2.861 1.218 2.455 2.131c-.338.76-2.44-1.01-3.041-.672s1.073.963.22 2.081-1.765 1.582-1.963 2.811-1.4 1.686-1.963.833c-.333-.5-.061-2.861-1.1-3.9a5.529 5.529 0 0 1-1.1-1.679 7.259 7.259 0 0 1 5.89-2.997Z"
          fill="#12b05e"
        />
        <path
          data-name="Path 833"
          d="M21.91 5.897c.425-.063.768-.092.783-.094a7.241 7.241 0 0 0-3.056-.672c-.164 0-.327.006-.489.017a7.226 7.226 0 0 1 2.762.749Z"
          fill="#98db7c"
        />
      </g>
      <g data-name="Group 265">
        <path
          data-name="Path 834"
          d="M2.563 17.554a.408.408 0 0 0 .408.408h2.867A2.244 2.244 0 0 0 8.08 15.72v-.2a2.244 2.244 0 0 0-2.242-2.242H2.971a.408.408 0 0 0-.408.408Zm.815-3.459h2.46a1.428 1.428 0 0 1 1.427 1.427v.2a1.428 1.428 0 0 1-1.427 1.427h-2.46Z"
        />
        <path
          data-name="Path 835"
          d="M2.971 11.531h2.155a1.913 1.913 0 1 0 0-3.826H2.971a.408.408 0 0 0-.408.408v3.01a.408.408 0 0 0 .408.408Zm.408-3.01h1.747a1.1 1.1 0 1 1 0 2.195H3.378Z"
        />
        <path
          data-name="Path 836"
          d="M27 9.465a.408.408 0 1 0-.733.357 6.809 6.809 0 0 1 .692 3.011q0 .192-.011.382a2.23 2.23 0 0 0-1.6-.274 5.12 5.12 0 0 0-1.573.639c-.378.209-.735.407-.91.322a2 2 0 0 0-1.879.039 1.331 1.331 0 0 0-.553 1.25 2.2 2.2 0 0 0 .966 1.511c.48.4.455.443.374.569a1.79 1.79 0 0 0-.088 1.817 1.707 1.707 0 0 0 .256.366 6.859 6.859 0 0 1-1.861.256q-.276 0-.547-.022a2.287 2.287 0 0 0-1.079-1.615c-.132-.089-.146-.182-.09-.587a1.283 1.283 0 0 0-.391-1.34c-.72-.543-1.423-.092-2.043.306-.207.133-.42.27-.644.384a1.877 1.877 0 0 0-.5.377 6.863 6.863 0 0 1-.645-7.838A5.33 5.33 0 0 0 15 10.526a1.761 1.761 0 0 1 .338.5.408.408 0 0 0 .738-.347 2.57 2.57 0 0 0-.5-.73 4.879 4.879 0 0 1-.915-1.341A6.878 6.878 0 0 1 21.4 6.084c-.608.15-1.1.379-1.126.836-.028.478.5.745 1.224 1.116a8.01 8.01 0 0 1 .957.541 1.009 1.009 0 0 1 .3.286 5.047 5.047 0 0 1-1.05-.419c-.727-.349-1.354-.65-1.811-.394a.626.626 0 0 0-.33.42.956.956 0 0 0 .288.766c.287.382.435.617.138 1.007a10.081 10.081 0 0 1-.788.89 3.792 3.792 0 0 0-1.258 2.108 1.043 1.043 0 0 1-.7.918.482.482 0 0 1-.526-.242 4.157 4.157 0 0 1-.147-.915c-.02-.2-.041-.4-.069-.619a.408.408 0 1 0-.809.1c.026.206.047.405.066.6a3.117 3.117 0 0 0 .277 1.282 1.3 1.3 0 0 0 1.1.621 1.342 1.342 0 0 0 .283-.031 1.837 1.837 0 0 0 1.336-1.582 3.029 3.029 0 0 1 1.045-1.674 10.9 10.9 0 0 0 .848-.961 1.45 1.45 0 0 0-.069-1.9c.248.088.574.245.783.345.692.333 1.29.62 1.754.449a.7.7 0 0 0 .406-.384c.131-.3.157-.751-.465-1.242a7.444 7.444 0 0 0-1.18-.693c-.189-.1-.44-.224-.615-.331a8.5 8.5 0 0 1 1.813-.34 6.881 6.881 0 0 1 2.318 1.821.408.408 0 0 0 .629-.519 7.69 7.69 0 0 0-12.811 1.449V6.831a1.692 1.692 0 0 0-1.282-1.639V4.01h.083a3.918 3.918 0 0 0 2.554-.791 3.516 3.516 0 0 0 .862-2.848.408.408 0 0 0-.357-.348A4.407 4.407 0 0 0 12 .791a2.388 2.388 0 0 0-.482.613 2.386 2.386 0 0 0-.482-.613A4.407 4.407 0 0 0 7.968.025a.408.408 0 0 0-.357.348 3.516 3.516 0 0 0 .862 2.848 3.918 3.918 0 0 0 2.554.791h.083v1.182a1.692 1.692 0 0 0-1.282 1.639v6.02a4.824 4.824 0 0 0-.847-.961A4.436 4.436 0 0 0 9.6 9.618a4.481 4.481 0 0 0-4.476-4.476H1.689A1.691 1.691 0 0 0 0 6.831v2.662a.408.408 0 0 0 .815 0V6.831a.875.875 0 0 1 .874-.874h3.437a3.658 3.658 0 0 1 2.98 5.783.408.408 0 0 0 .09.565 4.009 4.009 0 0 1 1.632 3.216v.2a4 4 0 0 1-3.99 3.99H1.689a.875.875 0 0 1-.874-.874v-7.714a.408.408 0 1 0-.815 0v7.712a1.691 1.691 0 0 0 1.689 1.689h4.149a4.8 4.8 0 0 0 3.99-2.13v.441a1.69 1.69 0 1 0 3.379 0v-2.562a7.691 7.691 0 0 0 14.568-3.44A7.618 7.618 0 0 0 27 9.465Zm-14.452-8.07a3.22 3.22 0 0 1 2.089-.578 2.436 2.436 0 0 1-.622 1.8 3.216 3.216 0 0 1-2.089.578 2.436 2.436 0 0 1 .621-1.8ZM9.02 2.616a2.436 2.436 0 0 1-.622-1.8 3.219 3.219 0 0 1 2.089.578 2.436 2.436 0 0 1 .622 1.8 3.217 3.217 0 0 1-2.089-.578Zm3.372 16.219a.874.874 0 0 1-1.748 0v-12a.874.874 0 1 1 1.748 0Zm3.264-1.272c.26-.132.5-.287.714-.424.655-.42.88-.516 1.112-.341.122.092.125.205.074.578A1.257 1.257 0 0 0 18 18.749a1.813 1.813 0 0 1 .7.819 6.866 6.866 0 0 1-3.349-1.758 1.1 1.1 0 0 1 .312-.247Zm7.23 1.549a.737.737 0 0 1-.473-.4.984.984 0 0 1 .05-1c.5-.767-.123-1.289-.532-1.635-.336-.284-.654-.552-.678-.939s.14-.486.193-.522a1.225 1.225 0 0 1 1.069.017c.556.27 1.093-.028 1.661-.343a4.4 4.4 0 0 1 1.324-.547 1.424 1.424 0 0 1 1.334.411 6.9 6.9 0 0 1-3.949 4.958Z"
        />
      </g>
    </svg>
  );
};
export default SvgBiotechnology;
